import { Button } from '@/components/atoms/Button';
import { Text } from '@/components/atoms/text';
import { colors } from '@/styles/theme/colors';
import { Box, ButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SearchMunicipalityFormFooter = styled(Box)(({ theme }) => ({
  position: 'sticky',
  bottom: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.common.white,
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    padding: theme.spacing(0, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

export const Buttons = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 3),
  '> button': {
    height: 44,

    '& + button': {
      flex: 1,
      padding: theme.spacing(1.25, 0),
    },

    [theme.breakpoints.down('md')]: {
      flex: 1,
      padding: theme.spacing(1, 0),
    },
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 0),
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const StyledSearchContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  minHeight: '14rem',
  [theme.breakpoints.down('md')]: {
    height: 'auto',
    minHeight: 'auto',
    overflowY: 'initial',
    paddingBottom: theme.spacing(10),
  },
  [theme.breakpoints.down('sm')]: {
    paddingBottom: theme.spacing(14),
  },
}));

export const ClassificationButtonGroup = styled(ButtonGroup)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  width: '100%',
  backgroundColor: colors.background,
  borderRadius: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(0.75, 1),
}));

const shouldForwardProp = (prop: PropertyKey) => !['active'].includes(prop as string);

export const ClassificationButton = styled(Button, { shouldForwardProp })<{
  active?: boolean;
}>(({ theme, active }) => ({
  color: active ? theme.palette.text.primary : theme.palette.text.secondary,
  backgroundColor: active ? theme.palette.common.white : 'transparent',
  borderRadius: theme.spacing(0.5),
  '&:hover': {
    backgroundColor: active ? theme.palette.action.selected : theme.palette.action.hover,
  },
}));

export const ErrorMessage = styled(Text)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: theme.typography.caption.fontSize,
  fontWeight: theme.typography.caption.fontWeight,
}));

export const ScoreFilterContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
}));
